import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/i18n";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Marketing from "@/pages/Marketing";
import About from "@/pages/About";
import Services from "@/pages/Services";
import SampleReport from "@/pages/SampleReport";
import Login from "@/pages/Login";
import Portal from "@/pages/Portal";
import Staff from "@/pages/Staff";
import Board from "@/pages/Board";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import AuthCallback from "@/pages/AuthCallback";
import PrintSuite from "@/pages/PrintSuite";
import RateCard from "@/pages/RateCard";
import SetPassword from "@/pages/SetPassword";
import ContractorPortal from "@/pages/ContractorPortal";

function Protected({ children, staffOnly = false, contractorOk = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", color: "var(--muted)" }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "contractor" && !contractorOk) return <Navigate to="/contractor" replace />;
  if (staffOnly && !["staff", "admin"].includes(user.role)) return <Navigate to="/portal" replace />;
  return children;
}

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Marketing />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/sample-report" element={<SampleReport />} />
      <Route path="/login" element={<Login />} />
      <Route path="/set-password" element={<SetPassword />} />
      <Route path="/portal" element={<Protected><Portal /></Protected>} />
      <Route path="/contractor" element={<Protected contractorOk><ContractorPortal /></Protected>} />
      <Route path="/staff" element={<Protected staffOnly><Staff /></Protected>} />
      <Route path="/board" element={<Protected><Board /></Protected>} />
      <Route path="/brand-suite" element={<Protected staffOnly><PrintSuite /></Protected>} />
      <Route path="/rate-card" element={<Protected staffOnly><RateCard /></Protected>} />
      <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Router />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
